export default __webpack_public_path__ + "static/typography-image-z-cdf4ee247906ef0ed9ecf437588a5a20.png";